import { ACCOUNT_CONDITION } from "../const/conditions";
var isPredeliveryAndTotalPaymentDueZero = function (conditions, totalMinimumPaymentDue) {
    return (conditions.includes(ACCOUNT_CONDITION.PRE_DELIVERY) &&
        Number(totalMinimumPaymentDue) === 0);
};
export default isPredeliveryAndTotalPaymentDueZero;
//# sourceMappingURL=isPredeliveryAndTotalPaymentDueZero.js.map